<template>
  <div class="">
    <div class="card p-5" :class="$style.container">
      <img width="231" height="48" src="../../../../assets/img/logo-istry-login.png" />

      <div class="text-dark my-3 text-left" style="font-size: 28px;">
        <strong>Hi, welcome to ISTRY</strong>
      </div>
      <div class="mb-2 text-left" style="font-size: 14px;color: #4C749F;">
        ISTRY (Indonesian Systemic Therapy) is a smart healthcare app that helps medical
        professionals easily find the right cancer treatments.
      </div>
      <a-form
        :model="loginForm"
        :rules="rules"
        layout="vertical"
        @finish="handleFinish"
        @finishFailed="handleFinishFailed"
        class="my-2"
      >
        <a-form-item name="email">
          <label for="email" style="color: #304E77;">E-mail</label>
          <a-input v-model:value="loginForm.email" placeholder="example@gmail.com" id="email" />
        </a-form-item>

        <a-button
          size="large"
          html-type="submit"
          class="btn w-100 d-flex align-items-center justify-content-center"
          :loading="loading"
          style="border-radius: 24px;background-color: #436894;color: white; padding-top: 30px;padding-bottom: 30px;font-size: 16px !important;"
        >
          <strong>Kirim Email</strong>
        </a-button>
      </a-form>
      <router-link :to="{ name: 'masuk' }" class="text-left d-flex align-items-center mt-4">
        <ArrowLeftOutlined :style="{ fontSize: '14px' }" />
        <span class="ml-3"> back to login</span>
      </router-link>
    </div>
  </div>
</template>
<script>
import { reactive, ref } from 'vue'
import { ArrowLeftOutlined } from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import { UserManagementAPI } from '@/services/axios/istry/pathwayService'

export default {
  name: 'VbForgotPassword',
  components: {
    ArrowLeftOutlined,
  },
  setup() {
    const loading = ref(false)

    const rules = {
      email: [
        {
          required: true,
          message: 'Please input your email!',
          trigger: 'change',
        },
        {
          type: 'email',
          message: 'Please enter a valid email!',
          trigger: 'change',
        },
      ],
    }

    const forgotForm = reactive({
      email: '',
    })
    const loginForm = reactive({
      email: '',
    })

    const handleFinish = async values => {
      try {
        loading.value = true
        const response = await UserManagementAPI.forgotPassword(values.email)

        if (response.exist) {
          notification.success({
            message: 'Email Sent Successfully',
            description:
              'Password reset link has been sent to your email. Please check your inbox.',
            duration: 5,
          })
        } else {
          notification.warning({
            message: 'Email Not Found',
            description: 'The email address you entered is not associated with any admin account.',
            duration: 5,
          })
        }
      } catch (error) {
        notification.error({
          message: 'Error',
          description:
            error.response?.data?.message || 'Failed to send reset email. Please try again.',
          duration: 5,
        })
      } finally {
        loading.value = false
      }
    }

    const handleFinishFailed = errorInfo => {
      console.log('Failed:', errorInfo)
    }

    return {
      rules,
      forgotForm,
      loginForm,
      loading,
      handleFinish,
      handleFinishFailed,
    }
  },
}
</script>
<style lang="scss" module>
@import '@/@vb/components/Auth/style.module.scss';
</style>
